import ReactGA from "react-ga4";

export const initGA = () => {
      ReactGA.initialize("G-LBSG9N78RL", {
        testMode: process.env.NODE_ENV === "development",
      });
}